import { reactive } from '@nzyme/vue-utils/reactivity/reactive.js';
import { useElement } from '@nzyme/vue-utils/useElement.js';
import { onMounted } from 'vue';
import { E2E } from '@sigma/env/environments.js';
const harnessSymbol = Symbol('testHarness');
export function useTestHarness(input) {
    if (!E2E) {
        return;
    }
    const harness = reactive(input);
    const element = useElement();
    onMounted(() => {
        if (!element.value) {
            return;
        }
        element.value[harnessSymbol] = harness;
    });
}
export function getTestHarness(element) {
    if (!E2E) {
        return null;
    }
    return element[harnessSymbol] ?? null;
}
//# sourceMappingURL=useTestHarness.js.map